<template>
  <div class="w-full h-full">
    <LayoutBuilder
      v-if="pictogram && remoteFile"
      ref="layoutBuilder"
      :pictogram="pictogram"
      :entity-id="projectId"
      :type-pictogram="pictogram.type"
      :can-actions-pictogram="canActionsPictogram"
      @epc-reload="_LoadPictogram"
    />

    <div v-else class="p-8 text-center">
      <b-icon pack="fas" icon="spinner" custom-class="fa-spin" size="is-large"></b-icon>
      <p class="mt-2 text-sm text-gray-500">{{ $t('loading') }}…</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LayoutBuilder from '../../components/pictograms/layout-builder/LayoutBuilder.vue'
import { getPictogram, getCurrentDxfUrl } from '../../components/pictograms/services/pictograms.service'
import { createLogger } from '../../components/pictograms/utils/logger'

const logger = createLogger('project-pictogram-view')

export default {
  name: 'AdminPictogramView',
  middleware: 'auth',
  title: 'pictogram',

  components: { LayoutBuilder },

  data() {
    return {
      pictogram: null,
      remoteFile: null,
      canActionsPictogram: {
        mode_dashboard: false,
        show_header:    true,
        save:           true,
        select_entity:  false,
      },
    }
  },

  computed: {
    ...mapGetters({ navData: 'app/navData' }),

    projectId() {
      return parseInt(this.$route.params.project_id ?? this.navData.project_id)
    },
    pictogramId() {
      return parseInt(this.$route.params.id)
    },
  },

  async created() {
    await this._LoadPictogram()
    await this._DownloadDxf()
  },

  // El LayoutBuilder se monta cuando ya tenemos pictograma + remoteFile.
  // En ese momento, inyectamos el File como si el usuario lo hubiera
  // subido por el dropzone para reusar todo el flow de parse/render.
  watch: {
    remoteFile(file) {
      if (!file) return
      this.$nextTick(() => {
        const lb = this.$refs.layoutBuilder
        if (lb && typeof lb._OnFileSelected === 'function') {
          lb._OnFileSelected(file)
        } else {
          logger.warn('LayoutBuilder no expone _OnFileSelected')
        }
      })
    },
  },

  methods: {
    async _LoadPictogram() {
      try {
        this.pictogram = await getPictogram(this.pictogramId)
      } catch (err) {
        logger.error('No se pudo cargar el pictograma:', err)
        this.$buefy.toast.open({
          message:  this.$t('error') || 'No se pudo cargar el pictograma',
          type:     'is-danger',
          position: 'is-top-right',
        })
      }
    },

    async _DownloadDxf() {
      try {
        const res = await getCurrentDxfUrl(this.pictogramId)
        if (!res?.url) throw new Error('no_dxf_url')

        // Fetch con credentials:'omit' — S3 signed URL trae X-Amz-Signature
        // y axios incluye Bearer global → conflicto "Only one auth mechanism allowed".
        const resp = await fetch(res.url, { method: 'GET', credentials: 'omit' })
        if (!resp.ok) throw new Error('dxf_download_failed')

        const blob = await resp.blob()
        const filename = res.original_filename || this.pictogram?.document?.original_filename || 'pictogram.dxf'
        this.remoteFile = new File([blob], filename, { type: 'application/octet-stream' })
      } catch (err) {
        logger.error('DownloadDxf error:', err)
        this.$buefy.toast.open({
          message:  this.$t(err.message) || err.message || 'No se pudo descargar el DXF',
          type:     'is-danger',
          position: 'is-top-right',
        })
      }
    },
  },
}
</script>
